import React, { Component } from "react";
import { AudioContext } from "../../contexts/AudioContext";
import { Link, Redirect } from "react-router-dom";
import Modal from "react-modal";
import firebase from "firebase";
import Number from "../Number";
import Counter from "../Counter";
import "./style.scss";
import ResultModal from "../ResultModal";
import CountUp from "react-countup";

class QuizPad extends Component {
  static contextType = AudioContext;
  constructor() {
    super();
    this.state = {
      animate: false,
      average: 0,
      equation: "",
      isBreath: false,
      isLoading: false,
      isOpenResultModal: false,
      isSum: false,
      lastScore: 0,
      selectedCount: 0,
      showResult: false,
      sum: 0,
      timeLeft: 0,
      hms: "",
      redirect: false,
      width: 0,
      height: 0,
      showLoader: false,
      isSignedIn: false,
      start: 0,
    };
    this.numbers = [];
    this.selectedNums = [];
    this.counter = 0;
    this.decimal = ((new Date().getTime() % 1000) / 1000).toFixed(3);
    this.summarize = new Audio(require("../../assets/audio/summarize.mp3"));
    this.fieldClick = new Audio(require(`../../assets/audio/fieldclick.mp3`));
    this.start = new Audio(require("../../assets/audio/start.mp3"));
    this.calculate = new Audio(require("../../assets/audio/calculate.mp3"));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  componentWillMount() {
    this.setState({ showLoader: true });
    //Play sound
    this.context.volumeDown();
    let audio = new Audio(require("../../assets/audio/loading.mp3"));
    audio.volume = 0.5;
    audio.loop = true;
    audio.play();
    ///////////////////////////
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({ isSignedIn: true });
        let i;
        for (i = 0; i < 49; i++) {
          this.numbers[i] = i + 1;
        }
        this.numbers.sort(() => 0.5 - Math.random());
        new Date().toLocaleString();
        Modal.setAppElement("body");
        localStorage.setItem("location", "quiz");
        let db = firebase.firestore();
        db.collection("average")
          .doc("average")
          .get()
          .then((doc) => {
            if (doc.data()) this.setState({ average: doc.data().averageScore });
            else this.setState({ average: 0 });
          });
        db.collection("users")
          .doc(localStorage.email)
          .get()
          .then((doc) => {
            if (doc.data()) {
              if (doc.data().lastScore > 0) {
                db.collection("users")
                  .doc(localStorage.email)
                  .get()
                  .then((doc) => {
                    db.collection("users")
                      .doc(localStorage.email)
                      .get()
                      .then((doc) => {
                        if (doc.data().timeLeft > 0) {
                          this.setState({ redirect: true, showLoader: false });
                          audio.pause();
                          audio.currentTime = 0;
                          this.context.volumeUp();
                        } else {
                          this.setState({ isBreath: true, showLoader: false });
                          audio.pause();
                          audio.currentTime = 0;
                          this.context.volumeUp();
                        }
                      });
                  });
              } else {
                audio.pause();
                audio.currentTime = 0;
                this.context.volumeUp();
                this.setState({ isBreath: true, showLoader: false });
              }
            }
          });
      } else {
        audio.pause();
        audio.currentTime = 0;
        this.context.volumeUp();
        this.setState({ isSignedIn: false, redirect: true, showLoader: false });
      }
    });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  decreaseCount = () => {
    this.setState({ selectedCount: this.state.selectedCount - 1 });
  };

  increaseCount = () => {
    if (this.state.selectedCount < 7)
      this.setState({ selectedCount: this.state.selectedCount + 1 });
  };

  handleClick = (info) => {
    //Play random click sound
    // const min = 1;
    // const max = 12;
    // const rand = min + Math.random() * (max - min);
    this.fieldClick.pause();
    this.fieldClick.currentTime = 0;
    this.fieldClick.play();
    ///////////////////////////

    let i;
    if (this.selectedNums.length > 0) {
      for (i = 0; i < this.selectedNums.length; i++) {
        if (this.selectedNums[i] === info) {
          this.selectedNums.splice(i, 1);
          return false;
        }
      }
      this.selectedNums[this.counter] = info;
    } else {
      this.selectedNums[this.counter] = info;
    }
    this.counter++;
  };

  handleClickStart = () => {
    this.start.play();

    const elem = document.getElementById("root");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
    this.setState({ isBreath: false });
  };

  handleClickCalculate = () => {
    let db = firebase.firestore();
    if (this.state.selectedCount === 7) {
      this.setState({ isLoading: true });
      //Play sound
      this.context.volumeDown();
      // let audio = new Audio(require("../../assets/audio/calculate.mp3"));
      this.calculate.loop = true;
      this.calculate.play();
      let number = 0;
      ///////////////////////////
      let oldScore = 0;
      let docRef = db.collection("users").doc(localStorage.getItem("email"));
      docRef
        .get()
        .then((doc) => {
          // Document was found in the cache. If no cached document exists,
          // an error will be returned to the 'catch' block below.
          if (doc.data().score) oldScore = doc.data().score;
          else oldScore = 0;
        })
        .catch(function (error) {
          console.log("Error getting cached document:", error);
        });
      this.setState({ isSum: true });
      setTimeout(() => {
        this.calculate.pause();
        this.calculate.currentTime = 0;
        this.summarize.volume = 1;
        this.setState({ isLoading: false, animate: true });
        let numbers = this.selectedNums.filter((number) => {
          return number > 0;
        });
        setTimeout(() => {
          let interval1 = setInterval(() => {
            this.summarize.pause();
            this.summarize.currentTime = 0;
            this.summarize.play();
            if (number >= parseInt(numbers[0])) {
              this.summarize.pause();
              this.summarize.currentTime = 0;
              clearInterval(interval1);
              number = 0;
            }
            number++;
          }, 10);
          this.setState({ start: 0 });
          this.setState({ sum: parseInt(numbers[0]) });
        }, 1500);
        setTimeout(() => {
          let interval2 = setInterval(() => {
            this.summarize.pause();
            this.summarize.currentTime = 0;
            this.summarize.play();
            if (number >= parseInt(numbers[1])) {
              this.summarize.pause();
              this.summarize.currentTime = 0;
              clearInterval(interval2);
              number = 0;
            }
            number++;
          }, 10);
          this.setState({ start: this.state.start + parseInt(numbers[0]) });
          this.setState({ sum: this.state.sum + parseInt(numbers[1]) });
        }, 3000);
        setTimeout(() => {
          let interval3 = setInterval(() => {
            this.summarize.pause();
            this.summarize.currentTime = 0;
            this.summarize.play();
            if (number >= parseInt(numbers[2])) {
              this.summarize.pause();
              this.summarize.currentTime = 0;
              clearInterval(interval3);
              number = 0;
            }
            number++;
          }, 10);
          this.setState({ start: this.state.start + numbers[1] });
          this.setState({ sum: this.state.sum + numbers[2] });
        }, 4500);
        setTimeout(() => {
          let interval4 = setInterval(() => {
            this.summarize.pause();
            this.summarize.currentTime = 0;
            this.summarize.play();
            if (number >= parseInt(numbers[3])) {
              this.summarize.pause();
              this.summarize.currentTime = 0;
              clearInterval(interval4);
              number = 0;
            }
            number++;
          }, 10);
          this.setState({ start: this.state.start + parseInt(numbers[2]) });
          this.setState({ sum: this.state.sum + parseInt(numbers[3]) });
        }, 6000);
        setTimeout(() => {
          let interval5 = setInterval(() => {
            this.summarize.pause();
            this.summarize.currentTime = 0;
            this.summarize.play();
            if (number >= parseInt(numbers[4])) {
              this.summarize.pause();
              this.summarize.currentTime = 0;
              clearInterval(interval5);
              number = 0;
            }
            number++;
          }, 10);
          this.setState({ start: this.state.start + parseInt(numbers[3]) });
          this.setState({ sum: this.state.sum + parseInt(numbers[4]) });
        }, 7500);
        setTimeout(() => {
          let interval6 = setInterval(() => {
            this.summarize.pause();
            this.summarize.currentTime = 0;
            this.summarize.play();
            if (number >= parseInt(numbers[5])) {
              this.summarize.pause();
              this.summarize.currentTime = 0;
              clearInterval(interval6);
              number = 0;
            }
            number++;
          }, 10);
          this.setState({ start: this.state.start + parseInt(numbers[4]) });
          this.setState({ sum: this.state.sum + parseInt(numbers[5]) });
        }, 9000);
        setTimeout(() => {
          let rSum = 0;
          let i;
          for (i = 0; i < this.selectedNums.length; i++) {
            if (this.selectedNums[i] > 0) rSum += this.selectedNums[i];
          }
          db.collection("users")
            .doc(localStorage.getItem("email"))
            .collection("scores")
            .add({
              time: new Date().getTime(),
              score: parseInt(rSum) + parseFloat(this.decimal),
              average: this.state.average,
            });
          let interval7 = setInterval(() => {
            this.summarize.pause();
            this.summarize.currentTime = 0;
            this.summarize.play();
            if (number >= parseInt(numbers[6])) {
              this.summarize.pause();
              this.summarize.currentTime = 0;
              clearInterval(interval7);
              number = 0;
            }
            number++;
          }, 10);
          this.setState({ start: this.state.start + numbers[5] });
          this.setState({ sum: this.state.sum + numbers[6] });
          if (oldScore < rSum) {
            db.collection("users")
              .doc(localStorage.getItem("email"))
              .update({
                score: parseInt(rSum) + parseFloat(this.decimal),
                lastScore: parseInt(rSum) + parseFloat(this.decimal),
                lastStatus: rSum < this.state.average ? "unlucky" : "lucky",
                notified: false,
              })
              .then((docRef) => {})
              .catch((error) => {
                console.error("Error adding document: ", error);
              });
            localStorage.setItem(
              "score",
              parseInt(rSum) + parseFloat(this.decimal)
            );
            localStorage.setItem(
              "lastScore",
              parseInt(rSum) + parseFloat(this.decimal)
            );
          } else {
            db.collection("users")
              .doc(localStorage.getItem("email"))
              .update({
                lastScore: parseInt(rSum) + parseFloat(this.decimal),
                lastStatus: rSum < this.state.average ? "unlucky" : "lucky",
                notified: false,
              })
              .then((docRef) => {})
              .catch((error) => {
                console.error("Error adding document: ", error);
              });
            localStorage.setItem(
              "lastScore",
              parseInt(rSum) + parseFloat(this.decimal)
            );
            localStorage.setItem("score", parseFloat(oldScore));
          }
        }, 10500);
        let j = 1;
        let equation = numbers[0] + " + ";
        let interval1 = setInterval(() => {
          this.setState({ equation: equation });
          if (j > 6) clearInterval(interval1);
          if (j !== 6) equation += numbers[j] + " + ";
          else equation += numbers[j];
          j++;
        }, 1500);
      }, 2000);
      setTimeout(() => {
        this.setState({ showResult: true });
      }, 14050);
      setTimeout(() => {
        this.setState({
          animate: false,
          isOpenResultModal: true,
        });
        //Play sound
        this.context.volumeDown();
        let fName =
          this.state.sum >= this.state.average ? "lucky.mp3" : "unlucky.mp3";
        let audio = new Audio(require(`../../assets/audio/${fName}`));
        audio.pause();
        audio.currentTime = 0;
        audio.play();
        setTimeout(() => {
          this.context.volumeUp();
        }, 3000);
        ///////////////////////////
      }, 14000);
    }
  };

  handleCloseModal = () => {
    this.setState({ isOpenResultModal: false });
  };

  NumberPad = () => {
    let i,
      j,
      k = 0;
    const list = [];
    for (i = 0; i < 7; i++) {
      const listItems = [];
      for (j = 0; j < 7; j++) {
        listItems[j] = this.state.isSum ? (
          <Number
            key={j}
            average={this.state.average}
            selectedCount={this.state.selectedCount}
            number={this.numbers[k]}
            selectedNums={this.selectedNums}
            isSum={true}
            animate={this.state.animate}
            showResult={this.state.showResult}
          />
        ) : (
          <Number
            key={j}
            average={this.state.average}
            increaseCount={this.increaseCount}
            decreaseCount={this.decreaseCount}
            selectedCount={this.state.selectedCount}
            selectedNums={this.selectedNums}
            isSum={false}
            handleClick={this.handleClick}
            info={this.numbers[k]}
          />
        );
        k++;
      }
      list[i] = (
        <div key={i} style={{ marginLeft: "2px", marginRight: "2px" }}>
          {listItems}
        </div>
      );
    }

    return (
      <div className={this.state.isBreath ? "numberpad" : "numberpad-appear"}>
        {list}
      </div>
    );
  };

  renderRedirect = () => {
    if (this.state.redirect) {
      if (this.state.isSignedIn) return <Redirect to="/profile" />;
      else return <Redirect to="/" />;
    }
  };

  renderResult = () => {
    if (
      this.state.sum &&
      !this.state.isLoading &&
      this.state.showResult &&
      this.state.sum > this.state.average
    ) {
      return (
        <div>
          <div className="container-result">YOU ARE LUCKY!</div>
        </div>
      );
    } else if (
      this.state.sum &&
      !this.state.isLoading &&
      this.state.showResult &&
      this.state.sum <= this.state.average
    ) {
      return (
        <div>
          <div className="container-result">NOT SO LUCKY!</div>
        </div>
      );
    }
  };

  renderSum = () => {
    let i;
    let equation = "";
    let numbers = this.selectedNums.filter((number) => {
      return number > 0;
    });
    for (i = 0; i < 7; i++) {
      if (i !== 6) equation += numbers[i] + " + ";
      else equation += numbers[i];
    }
    return equation;
  };

  render() {
    return (
      <>
        {!this.state.showLoader ? (
          <>
            {this.state.isOpenResultModal ? (
              <ResultModal
                average={this.state.average}
                handleCloseModal={this.handleCloseModal}
                sum={this.state.sum}
                decimal={this.decimal}
                isTest={false}
              />
            ) : (
              <div className="container">
                {this.renderRedirect()}
                {this.state.isBreath ? (
                  <div className="container-comment">
                    <div className="container-comment-profile">
                      <img
                        alt="profile"
                        className="container-comment-profile-avatar"
                        src={localStorage.getItem("photo")}
                      ></img>
                      <div className="container-comment-profile-nickname">
                        {localStorage.getItem("nickName")}
                      </div>
                    </div>
                    <div className="container-comment-comment">
                      Take a deep breath, relax <br />
                      and get lucky :)
                    </div>
                    <button
                      className="container-comment-button"
                      onClick={this.handleClickStart}
                    >
                      START GAME
                    </button>
                  </div>
                ) : (
                  ""
                )}
                {this.state.showResult ? this.renderResult() : ""}
                <div className="container-header">
                  {this.state.isSum && !this.state.isLoading ? (
                    <div className="container-header-left">
                      Your score is:
                      <br />
                      <CountUp
                        start={this.state.start}
                        end={this.state.sum}
                        duration={0.5}
                        className="container-header-left-score"
                        style={
                          this.state.showResult &&
                          this.state.sum < this.state.average
                            ? { color: "red" }
                            : { color: "#ffcc00" }
                        }
                      />
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {!this.state.isLoading ? (
                    <img
                      alt="logo"
                      className={
                        this.state.isSum
                          ? "container-header-logo"
                          : "container-header-logo_breath"
                      }
                      src={require("./../../assets/images/logo.svg")}
                    ></img>
                  ) : (
                    ""
                  )}
                  {this.state.isSum && !this.state.isLoading ? (
                    <div className="container-header-right">
                      Average to bit is:
                      <div className="container-header-right-score">
                        {this.state.average}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
                {this.state.isSum && !this.state.isLoading ? (
                  !this.state.showResult ? (
                    this.state.equation ? (
                      <div className="container-equation">
                        {this.state.equation}
                      </div>
                    ) : (
                      <div style={{ height: "30px" }}></div>
                    )
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {this.state.isLoading ? (
                  <div className="loader-container">
                    <img
                      alt="loader"
                      src={require(`../../assets/images/SVG/1.svg`)}
                      className="loader"
                    ></img>
                    <div>PREPARING SCORE SCREEN...</div>
                  </div>
                ) : (
                  <>
                    {this.state.isSum ? (
                      ""
                    ) : (
                      <>
                        <div
                          style={{
                            marginTop:
                              window.screen.orientation === "portrait-primary"
                                ? "50px"
                                : "110px",
                          }}
                        ></div>
                        <Counter
                          selectedCount={this.state.selectedCount}
                          breath={this.state.isBreath}
                        ></Counter>
                      </>
                    )}
                    {this.NumberPad()}
                  </>
                )}
                {!this.state.isLoading &&
                !this.state.animate &&
                !this.state.isSum &&
                !this.state.isBreath ? (
                  this.state.selectedCount === 7 ? (
                    <button
                      className="container-button"
                      onClick={this.handleClickCalculate}
                    >
                      CHECK YOUR LUCK
                    </button>
                  ) : this.state.selectedCount === 0 ? (
                    <div style={{ fontSize: "22px", lineHeight: "95px" }}>
                      Select Your Lucky 7 Fields
                    </div>
                  ) : (
                    <button
                      className="container-button-diabled"
                      disabled={true}
                    >
                      CHECK YOUR LUCK
                    </button>
                  )
                ) : (
                  <div style={{ height: "20px" }}></div>
                )}
                {!this.state.animate &&
                this.state.isSum &&
                !this.state.isLoading &&
                this.state.showResult ? (
                  <div className="container-footer">
                    <Link to={{ pathname: "/chart", state: "rank" }}>
                      <button className="container-footer-btnRank">
                        MY RANK
                      </button>
                    </Link>
                    <Link to="/profile">
                      <button className="container-footer-profile">
                        My Profile
                      </button>
                    </Link>
                    {/* <Link
                      to={{ pathname: "/challenge" }}
                      style={{ textDecoration: "none" }}
                    >
                      <button className="container-footer-btnChallenge">
                        <div>CHALLENGE FRIENDS</div>
                        <img
                          alt="facebook"
                          src={require("../../assets/images/facebook.svg")}
                        ></img>
                      </button>
                    </Link> */}
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </>
        ) : (
          <div className="loader-container">
            <img
              alt="loader"
              src={require(`../../assets/images/SVG/1.svg`)}
              className="loader"
            ></img>
            <div>LOADING LUCKY PAD...</div>
          </div>
        )}
      </>
    );
  }
}

export default QuizPad;
